import { render, staticRenderFns } from "./cModalDeliverySale.vue?vue&type=template&id=5c72009c&scoped=true"
import script from "./cModalDeliverySale.vue?vue&type=script&lang=js"
export * from "./cModalDeliverySale.vue?vue&type=script&lang=js"
import style0 from "./cModalDeliverySale.vue?vue&type=style&index=0&id=5c72009c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72009c",
  null
  
)

export default component.exports